<!-- <div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div class="layout-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-config></app-config>
    <div class="layout-mask"></div>
</div> -->


<div class="global-wrapper" [ngClass]="containerClass">
    <!-- <app-topbar></app-topbar> -->
    <app-sidebar class="sidebar" [ngClass]="headerClass"></app-sidebar>
    <div class="menu-overlay"></div>

    <div class="global-data-container">
        
        <!--  -->
        <div class="data-wrapper">
           <router-outlet></router-outlet>
            <!-- <app-footer></app-footer> -->
            <!-- <app-config></app-config>  -->
        </div>
    </div>
    <div class="layout-mask"></div>
</div>